function bindInputWithOptionsMaker() {
  return input => {
    return {
      ...input,
      entry: {
        ...input.entry,
        asType(node) {
          const expectedEntryFormat = input.entry.schema.parse({});
          if (node != null && node.type !== expectedEntryFormat.type) {
            throw new Error(`assertDropdownInputEntry(): Expected node to be ${expectedEntryFormat.type}, received ${node.type}`);
          }
          return node ?? undefined;
        }
      }
    };
  };
}

export { bindInputWithOptionsMaker };
//# sourceMappingURL=util.make-input-with-options.js.map
